import getters from './getters'
import mutations from './mutations'
import actions from './actions'
const state = {
  serviceProviderList: '',
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}


// WEBPACK FOOTER //
// ./src/store/modules/serviceProvider/index.js